<template>
  <div class="chart" :style="`--percentage: ${number}`">
    <span class="chart__title"> {{ title }} </span>
    <div class="chart__label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: Number,
    },
    filter: {
      required: false,
      type: Function,
      default: (value) => value,
    },
    percent: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      const symbol = this.percent ? "%" : "";
      return `${this.value}${symbol}`;
    },
    number() {
      return this.percent ? this.value : 100;
    },
  },
};
</script>

<style lang="sass" scoped>
$primary: $blue-6
$secondary: $blue-1
$size: 180px

.chart
  width: $size
  height: calc($size / 2)
  margin: 8px auto
  padding-bottom: 5px
  padding-top: 32px
  position: relative
  overflow: hidden
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  box-sizing: border-box

  &:after
    content: ''
    width: $size
    height: $size
    border: 8px solid
    border-color: $secondary $secondary $primary $primary
    position: absolute
    border-radius: 50%
    left: 0
    top: 0
    box-sizing : border-box
    transform: rotate( calc( 1deg * ( -45 + var(--percentage) * 1.8 ) ) )
    animation : fillAnimation 1s ease-in

  &__title
    font-size: 32px
    line-height: 46px

  &__label
    margin: -8px
</style>
